import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../Firebase';

import "./ActivateCapsuleModalContent.css";
import Calendar from 'react-calendar';


const INITIAL_STATE = {
    selectedEndDate: null,
    capsuleID: null,
    error: null,
};


class ActivateCapsuleModalFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE, user: props.user };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user !== this.state.user) {
            this.setState({ user: nextProps.user })
        }
    }

    componentDidMount() {

        this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

            if (currentUser === null) {
                return
            }
            const capsuleID = this.props.capsuleID
            this.setState({ capsuleID })
        });
    }

    onChange = date => {
        this.setState({
            selectedEndDate: date
        })
    };

    onSubmitActivateCapsule = async event => {

        const { selectedEndDate, capsuleID, user } = this.state;
        const timestamp = Date.now();
        let newHistoric = { date: timestamp, firstname: user.firstname, lastname: user.lastname, picture: user.image_url_profile, status: "activated" }
        await this.props.firebase.db
            .collection('capsules')
            .doc(capsuleID).update({ endDate: new Date(selectedEndDate).getTime(), startedDate: new Date().getTime(), status: 'begin' })
        await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('historic').add(newHistoric)
        this.props.onClose('success');
    }

    render() {
        const { selectedEndDate, error } = this.state;

        return (

            <>

                <div className="modal-accept-container">

                    <div className="accept-header">
                        Sélectionner une date de fin approximative pour la réalisation de la capsule.
                        </div>


                    <div className="modal-accept-form-container">

                        <div>
                            <div className="modal-accept-form-group">

                                <Calendar
                                    className={(window.innerWidth > 700) ? "modal-calendar-desktop" : "modal-calendar-mobile"}
                                    minDate={new Date()}
                                    onChange={this.onChange}
                                    value={selectedEndDate}
                                />


                                <button type="button" onClick={this.onSubmitActivateCapsule} className="modal-accept-button">OK</button>


                            </div>
                        </div>

                        {error && <p>{error.message}</p>}
                    </div>

                </div>
            </>
        );
    }
}


const ActivateCapsuleModalForm = withRouter(withFirebase(ActivateCapsuleModalFormBase));

export { ActivateCapsuleModalForm };
